import React, { useState } from 'react';
import styles from './ReintentoServicio.module.css';
import btnCerrar from "../../img/btn-cerrar.png"
import DOMPurify from "dompurify";

const ReintentoServicio = ({ errorCargando, handleReintento }) => {
    const [ mostrar, setMostrar ] = useState(true)
    
    const ocultaMensaje = () => {
        setMostrar(false)
    }

    return (
        <React.Fragment>
            {errorCargando && mostrar
                ? <div className={styles['modal']}>
                    <div className={styles['modal-content']}>
                        <div className={styles['contenedor']}>
                            <img className={styles['img_cerrar']} src={btnCerrar} alt="btnCerrar" onClick={ocultaMensaje} />
                            <div className={styles['texto']}>
                                <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorCargando) }}></label>
                            </div>
                            <div className={styles['boton']}>
                                <button className={`${styles['flex5']} ${styles['default']} ${styles['call-to-action']}`} onClick={handleReintento}>
                                    Renovar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default ReintentoServicio;